import React from 'react';
import { useParallax } from '@hooks/useParallax';

export const Nebula: React.FC = () => {
  const offset1 = useParallax(0.3);
  const offset2 = useParallax(0.5);
  const offset3 = useParallax(0.2);

  return (
    <>
      {/* Purple nebula - slow */}
      <div
        className="absolute inset-0 opacity-30"
        style={{
          transform: `translateY(${offset1}px)`,
          zIndex: 2,
        }}
      >
        <div
          className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full blur-3xl"
          style={{
            background: 'radial-gradient(ellipse at center, rgba(138,43,226,0.4) 0%, rgba(0,0,0,0) 70%)',
          }}
        />
      </div>

      {/* Cyan nebula - medium */}
      <div
        className="absolute inset-0 opacity-20"
        style={{
          transform: `translateY(${offset2}px)`,
          zIndex: 2,
        }}
      >
        <div
          className="absolute top-1/2 right-1/4 w-[500px] h-[500px] rounded-full blur-3xl"
          style={{
            background: 'radial-gradient(ellipse at center, rgba(0,255,255,0.3) 0%, rgba(0,0,0,0) 70%)',
          }}
        />
      </div>

      {/* Magenta nebula - fast */}
      <div
        className="absolute inset-0 opacity-25"
        style={{
          transform: `translateY(${offset3}px)`,
          zIndex: 2,
        }}
      >
        <div
          className="absolute bottom-1/4 left-1/3 w-80 h-80 rounded-full blur-3xl"
          style={{
            background: 'radial-gradient(ellipse at center, rgba(255,0,255,0.35) 0%, rgba(0,0,0,0) 70%)',
          }}
        />
      </div>
    </>
  );
};
